import { Component, OnInit, ViewChild, Input, Output, EventEmitter, forwardRef } from '@angular/core';

import { CompleterService, CompleterData, CompleterCmp, CompleterItem, CtrCompleter, CtrDropdown } from 'ng2-completer';

import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'auto-completer',
  templateUrl: './auto-completer.component.html',
  styleUrls: ['./auto-completer.component.css'],

  providers: [
	  {
		  provide: NG_VALUE_ACCESSOR,
		  useExisting: forwardRef(() => AutoCompleterComponent),
		  multi: true
	  }
  ]
})
export class AutoCompleterComponent implements OnInit, ControlValueAccessor {

	constructor(private completerService: CompleterService) {
	}

	public searchStr: string;
	protected dataService: CompleterData = this.completerService.local([], null, null);
	public isOpenAutoComplete: boolean = false;

	isLastAutoOpen: Boolean = false;

	isSelected: boolean = false;

	ngOnInit() {
	}

	writeValue(value: any) {
		if (value !== undefined)
			this.searchStr = value;
	}
	propagateChange = (_: any) => { };

	registerOnChange(fn) {
		this.propagateChange = fn;
	}

	registerOnTouched() { }

	@Input("maxChars") private maxChars: number = 60;
	@Input("textNoResults") private textNoResults: string;
	@Input("placeholder") private placeholder: string;
	@Input("autoCompleterName") private autoCompleterName: string;
	@Input("loadingBusy") private loadingBusy: boolean;

	@Input("keyId") private keyId: string;

	@Output() public selected = new EventEmitter<number>();

	@ViewChild("autoCompleter") private autoCompleter: CompleterCmp;

	onKeydown(event: KeyboardEvent) {
		if (event.key == 'Enter') {
			event.preventDefault();
			return;
		}

		if (event.key != 'PageDown' && event.key != 'PageUp')
			return;

		let completer: any = this.autoCompleter.completer;
		let dropdown: any = completer.dropdown;

		//console.log(dropdown.dropdownRowTop());
		//console.log(dropdown.dropdownHeight());

		if (!dropdown) {
		}
		else {
			let rowHeight = dropdown.rows.length > 0 ?
				dropdown.rows[0].row.getNativeElement().parentElement.getBoundingClientRect().height : 19.2;
			let numScrollRows =
				Math.max(Math.floor(dropdown.el.nativeElement.clientHeight / rowHeight) - 1, 0);

			if (event.key == 'PageUp')
				numScrollRows = -numScrollRows;

			let currRowIx = Math.ceil(dropdown.el.nativeElement.scrollTop / rowHeight);

			let highlightRowIx = currRowIx + numScrollRows;

			if (highlightRowIx < 0)
				highlightRowIx = 0;
			if (highlightRowIx >= dropdown.rows.length)
				highlightRowIx = dropdown.rows.length - 1;

			dropdown.dropdownScrollTopTo(/*calculating offset not absolute scrollTop: */
				highlightRowIx * rowHeight - dropdown.el.nativeElement.scrollTop);

			if (dropdown.currHighlighted)
				dropdown.currHighlighted.row.setHighlighted(false);
			dropdown.rows[highlightRowIx].row.setHighlighted(true);
			dropdown.currHighlighted = dropdown.rows[highlightRowIx];
			completer._hasHighlighted = true;
		}

		event.preventDefault();
		event.stopPropagation();
		event.stopImmediatePropagation();

		return false;
	}

	onKeyup(event: KeyboardEvent) {
		//debugger;
		if (event.key != 'Enter')
			return;
		//console.log(this.isOpenAutoComplete);

		if (this.isOpenAutoComplete || this.isLastAutoOpen) {
			this.autoCompleter.close();
		}
		else {
			this.autoCompleter.open();
			//this.autoCompleter.focus();
		}

		this.isLastAutoOpen = this.isOpenAutoComplete;

	}

	public onOpened(isOpen: boolean) {
		//console.log('Opened? ' + this.autoCompleter.placeholder + ' ' + isOpen + ' ' + this.isOpenAutoComplete);
		this.isLastAutoOpen = this.isOpenAutoComplete;
		this.isOpenAutoComplete = isOpen;

		if (!isOpen) {

			//console.log('Being closed: isSelected= ' + this.autoCompleter.placeholder + ' ' + this.isSelected);

			setTimeout(() => {
				//console.log('closing: isSelected= ' + this.autoCompleter.placeholder +
				//	' ' + this.isSelected + ' bluredWithouSelection= ' + this.bluredWithouSelection);
				//if (this.isSelected) {
				if (this.isSelected && !this.bluredWithouSelection /*This is for handling tab:*/ && this.isLastAutoOpen) {
					//console.log('Being re-focused...' + this.autoCompleter.placeholder + ' ');
					//this.isSelected = false;
					this.autoCompleter.focus();
				}
				else {

					//console.log('closing: bluredWithouSelection= ' + this.autoCompleter.placeholder + ' ' + this.bluredWithouSelection);

					if (this.bluredWithouSelection) {
						this.searchStr = '';
						this.bluredWithouSelection = false;
					}

				}
			}, 0);
			//console.log(this.autoCompleter.value);
		}
		else {
			//console.log('Openning: bluredWithouSelection= ' + this.autoCompleter.placeholder + ' ' + this.bluredWithouSelection);
		}
	}

	onFocus() {
		this.isSelected = false;
		//console.log('Focused: isSelected=' + this.isSelected);

	}

	hasSelection: boolean = false;
	bluredWithouSelection: boolean = false;

	onBlur() {
		//debugger;

		//console.log('blur: hasSelection=' + this.autoCompleter.placeholder + ' ' + this.hasSelection + ' isOpenAutoComplete= ' + this.isOpenAutoComplete );

		if (!this.hasSelection) {
			this.bluredWithouSelection = true;

			if (!this.isOpenAutoComplete) {
				this.searchStr = '';
				this.bluredWithouSelection = false;/*This is to eliminate handling of bluredWithouSelection while closing within onOpened handler*/
			}
		}
	}

	onSelected(selected: CompleterItem) {
		///debugger;
		//console.log('Selection Start: ' + this.autoCompleter.placeholder + ' '
		//	+ this.isSelected + ' selected= ' + selected + ' ' + !!selected + ' bluredWithouSelection= ' + this.bluredWithouSelection);
		this.isSelected = true;

		this.hasSelection = !!selected; 
		this.bluredWithouSelection = false;

		let keyId: number = -1;
		if (selected)
			keyId = selected.originalObject[this.keyId];
		//this.setSelectedCity(cityId);

		this.selected.emit(keyId);

		this.propagateChange(this.searchStr);
		//console.log('Selection End: ' + this.autoCompleter.placeholder + ' ' + this.isSelected);
	}

	setDataService(dataService: CompleterData) {
		//this.dataService = null;
		if (this.dataService)
			this.dataService.dataSourceChange.emit();
		this.dataService = dataService;
		//this.dataService.dataSourceChange.emit();
		//this.autoCompleter.datasource = this.dataService;
	}

	toggleAutoOpen(event) {
		if (this.autoCompleter.isOpen())
			this.autoCompleter.close();
		else {
			this.autoCompleter.open();
			this.autoCompleter.focus();
		}
	}


}



// WEBPACK FOOTER //
// ./src/app/auto-completer/auto-completer.component.ts